"use strict";

Shopify.theme.jsCustomCookieFigure = {
  init: function init($section) {
    Shopify.theme.jsCustomCookieFigure = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section
    this.$steps = $section.find('.custom-cookie__step')
    this.previousStep = 1
    this.quantity = 0
    this.tempDate = new Date(new Date().setDate(new Date().getDate() + 7))
    this.defaultDate = `${this.tempDate.getMonth() + 1}/${this.tempDate.getDate()}/${this.tempDate.getFullYear()}`
    this.selectedDate = this.defaultDate
    this.defaultDateGap = '+14'
    this.rush = false
    this.additional_message = ''
    this.selectedImage1 = ''
    this.selectedImage2 = ''
    this.selectedImage3 = ''
    this.order_type = 'Delivery'
    this.initStep2()
    this.skipdates = ''
    this.applyManagementFees = false

  },
  initStep2: function initStep2() {
    let _self = this
    _self.currentStep = 2
    _self.$steps.hide()
    _self.handleNavigation()

    let $parent = _self.$section.find('.custom-cookie__step-2').show()
    let $slider = $parent.find('.custom-cookie__quantities input[type="range"]')
    let $quantity = $parent.find('.quantity')
    let $management = $parent.find('[data-management-fees]')
    let $price = $parent.find('.price')

    _self.quantity = $slider.val()

    $slider.on('input', function (e) {
      let quantity = parseInt($(this).val())
      _self.quantity = quantity
      let priceLabel = (quantity * parseFloat(_self.singlePrice)).toFixed(2)
      if (quantity >= _self.default_quantity) {
        _self.applyManagementFees = false
        $management.removeClass('is-active')
      } else {
        _self.applyManagementFees = true
        $management.addClass('is-active')
      }

      $quantity.text(quantity)
      $price.text(priceLabel)

    })

  },
  initStep3: function initStep3() {

    let _self = this

    _self.currentStep = 3
    _self.$steps.hide()
    _self.handleNavigation()

    var skipDates = $('.custom-cookie__step-3').attr('data-skipdate');
    skipDates = skipDates.split(',');
    let $parent = _self.$section.find('.custom-cookie__step-3').show()
    let $calendor = $("[ data-calendor]").datepicker({
      altField: "[data-selected-date]",
      buttonText: "Choose",
      altFormat: "mm/dd/yy",
      defaultDate: _self.defaultDateGap,
      minDate: 0,
      onSelect: function (date, instance) {
        _self.rush = false
        let selectedDate = new Date(date).getTime()
        let incrementeDate = new Date().setDate(new Date().getDate() + 6)
        _self.selectedDate = date
        if (incrementeDate > selectedDate) {
          _self.showPopup('rush', instance)
        }
      },
      beforeShowDay: function (date) {
        var currentDate = jQuery.datepicker.formatDate('yy-mm-dd', date);
        if (skipDates.indexOf(currentDate) > -1) {
          if (currentDate == _self.defaultDate) {
            _self.defaultDateGap = "+14"
          }
          return [false, 'disabled', 'Order Booked']
        } else {
          return [true, 'Active', 'Available']

        }

      }
    });
    $(document).on('click', 'td.disabled', function (e) {
      e.preventDefault()
      _self.showPopup('booked')
    })

  },
  showPopup: function showPopup(type, instance) {
    let _self = this
    let $parent = _self.$section.find(`.custom-cookie__step-${_self.currentStep}`)
    let $bookedPopup = $parent.find('[data-booked-popup]')
    let $rushPopup = $parent.find('[data-rush-popup]')
    $bookedPopup.find('.close').on('click')
    $rushPopup.find('.close').off('click')
    $rushPopup.find('[data-rush-selected]').off('click')

    if (type == 'booked') {
      $bookedPopup.addClass('is-active')
      $('body').addClass('has-overlay')
      $bookedPopup.find('.close').on('click', function () {
        $('body').removeClass('has-overlay')
        $bookedPopup.removeClass('is-active')
      })
    } else {
      $rushPopup.addClass('is-active')
      $('body').addClass('has-overlay')
      $rushPopup.find('.close').on('click', function () {
        $rushPopup.removeClass('is-active')
        $('body').removeClass('has-overlay')
        _self.rush = false
        $('[data-calendor]').datepicker("setDate", _self.defaultDateGap);

      })
      $rushPopup.find('[data-rush-selected]').on('click', function () {
        $rushPopup.removeClass('is-active')
        $('body').removeClass('has-overlay')
        _self.rush = true
        //               instance.datepicker("setDate",_self.defaultDate);

      })
    }
  },
  initStep4: function initStep4() {
    let _self = this
    _self.currentStep = 4
    _self.$steps.hide()
    _self.handleNavigation()

    let $parent = _self.$section.find('.custom-cookie__step-4').show()
    let $fileInput = $parent.find('#file-upload-1')
    let $loader = $parent.find('.is-loading')
    let $placeholder = $parent.find('[data-image-wrapper]')
    $fileInput.off('change')

    $fileInput.on('change', function () {
      var file_data = $(this).prop('files')[0];
      var filesize = file_data.size / (1024 * 1024);
      if (filesize > 3) {
        alert("Your file size is greater than 3Mb. Please upload the image with file size less than 3Mb !!");
        return false;
      };

      if (file_data) {
        var form_data = new FormData();
        form_data.append('file', file_data);
        $.ajax({
          url: 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-ff89ac1d-0c4c-482c-9143-0df6032df621/cupcake-market-nyc/upload', //'https://cartbrain.net/CookiesProfileUploader/upload.php', 
          dataType: 'text',
          cache: false,
          contentType: false,
          processData: false,
          data: form_data,
          type: 'post',
          beforeSend: function () {
            $loader.removeClass('is-hidden');
          },
          success: function (php_script_response) {
            $('#fileurl-1').attr('data-filepath', php_script_response);
            $placeholder.removeClass('hidden').attr('src', php_script_response)
            _self.selectedImage1 = php_script_response
          },
          complete: function () {
            $loader.addClass('is-hidden');
          }
        });
      }
    });

  },
  initStep5: function initStep5() {
    let _self = this
    _self.currentStep = 5
    _self.$steps.hide()
    _self.handleNavigation()

    let $parent = _self.$section.find('.custom-cookie__step-5').show()
    let $fileInput = $parent.find('#file-upload-2')
    let $loader = $parent.find('.is-loading')
    let $placeholder = $parent.find('[data-image-wrapper]')
    $fileInput.off('change')

    $fileInput.on('change', function () {
      var file_data = $(this).prop('files')[0];
      var filesize = file_data.size / (1024 * 1024);
      if (filesize > 3) {
        alert("Your file size is greater than 3Mb. Please upload the image with file size  less than 3Mb !!");
        return false;
      };
      if (file_data) {
        var form_data = new FormData();
        form_data.append('file', file_data);
        $.ajax({
          url: 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-ff89ac1d-0c4c-482c-9143-0df6032df621/cupcake-market-nyc/upload', //'https://cartbrain.net/CookiesProfileUploader/upload.php', 
          dataType: 'text',
          cache: false,
          contentType: false,
          processData: false,
          data: form_data,
          type: 'post',
          beforeSend: function () {
            $loader.removeClass('is-hidden');
          },
          success: function (php_script_response) {
            $('#fileurl-2').attr('data-filepath', php_script_response);
            $placeholder.removeClass('hidden').attr('src', php_script_response)
            _self.selectedImage2 = php_script_response
          },
          complete: function () {
            $loader.addClass('is-hidden');
          }
        });
      }
    });

  },
  initStep6: function initStep6() {
    let _self = this
    _self.currentStep = 6
    _self.$steps.hide()
    _self.handleNavigation()

    let $parent = _self.$section.find('.custom-cookie__step-6').show()
    let $fileInput = $parent.find('#file-upload-3')
    let $loader = $parent.find('.is-loading')
    let $placeholder = $parent.find('[data-image-wrapper]')
    $fileInput.off('change')

    $fileInput.on('change', function () {
      var file_data = $(this).prop('files')[0];
      var filesize = file_data.size / (1024 * 1024);
      if (filesize > 3) {
        alert("Your file size is greater than 3Mb. Please upload the image with file size less than 3Mb !!");
        return false;
      };
      if (file_data) {
        var form_data = new FormData();
        form_data.append('file', file_data);
        $.ajax({
          url: 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-ff89ac1d-0c4c-482c-9143-0df6032df621/cupcake-market-nyc/upload', //'https://cartbrain.net/CookiesProfileUploader/upload.php', 
          dataType: 'text',
          cache: false,
          contentType: false,
          processData: false,
          data: form_data,
          type: 'post',
          beforeSend: function () {
            $loader.removeClass('is-hidden');
          },
          success: function (php_script_response) {
            $('#fileurl-3').attr('data-filepath', php_script_response);
            $placeholder.removeClass('hidden').attr('src', php_script_response)
            _self.selectedImage3 = php_script_response
          },
          complete: function () {
            $loader.addClass('is-hidden');
          }
        });
      }
    });

  },
  initStep7: function initStep7() {
    let _self = this
    _self.currentStep = 7
    _self.$steps.hide()
    _self.handleNavigation()

    let $parent = _self.$section.find('.custom-cookie__step-7').show()
    let $input1 = $parent.find('#selection-message')

    $input1.off('change')
    $input1.on('change', function () {
      _self.additional_message = $(this).val()
    })

  },
  initStep8: function initStep8() {
    let _self = this
    _self.currentStep = 8
    _self.$steps.hide()
    _self.handleNavigation()

    let $parent = _self.$section.find('.custom-cookie__step-8').show()
    let $inputs = $parent.find('[name="order-type"]')

    $inputs.off('change')

    $inputs.on('change', function (e) {
      _self.order_type = $(this).data('value')
    })
  },
  initStep9: function initStep9() {
    let _self = this
    let nonce = new Date().getTime()
    _self.currentStep = 9
    let items = [{
      id: _self.selectedProduct,
      quantity: _self.quantity,
      properties: {
        '_identifier': nonce,
        quantity: _self.quantity,
        selected_date: _self.selectedDate,
        additional: _self.additional_message,
        image_1: _self.selectedImage1,
        image_2: _self.selectedImage2,
        image_3: _self.selectedImage3,
        _rush: _self.rush,
        order_type: _self.order_type
      }
    }]
    if (_self.applyManagementFees) {
      items.push({
        id: _self.management_product,
        quantity: 1,
        properties: {
          '_identifier': nonce,
          '_isManagmentFees': true
        }
      })
    }
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { items },
      success: function success(product) {
        window.location.href = '/cart'
      },
      error: function error(err) {
        _self.handleError(err.responseJSON.description)
      }
    })


  },
  handleNavigation: function handleNavigation() {
    let _self = this
    _self.$section.find('[data-error]').addClass('is-hidden')

    let $parent = _self.$section.find('.custom-cookie__navigation')
    let $prev = $parent.find('[prev-step-button]')
    let $next = $parent.find('[next-step-button]')

    $prev.off('click')
    $next.off('click')

    if (_self.currentStep == 2) {
      $prev.attr('disabled', false).removeClass('is-hidden')
      $next.attr('disabled', false).removeClass('is-hidden')
      $next.on('click', function (e) {
        if (_self.quantity < parseInt(_self.min_quantity)) {
          _self.handleError('Please Select a quantity')
          return
        }
        if (_self.quantity > parseInt(_self.max_quantity)) {
          _self.handleError('Please Select a valid quantity')
          return
        }
        _self.previousStep = 2
        _self.initStep3()
      })
      $prev.on('click', function (e) {
        _self.previousStep = 2
        window.location.href = _self.returnUrl
      })
    }
    
    if (_self.currentStep == 3) {
      $prev.attr('disabled', false).removeClass('is-hidden')
      $next.attr('disabled', false).removeClass('is-hidden')
      $next.on('click', function (e) {
        _self.previousStep = 3
        _self.initStep4()
      })
      $prev.on('click', function (e) {
        _self.previousStep = 3
        _self.initStep2()
      })
    }
    
    if (_self.currentStep == 4) {
      $prev.attr('disabled', false).removeClass('is-hidden')
      $next.attr('disabled', false).removeClass('is-hidden')
      $next.on('click', function (e) {
        if (_self.notRequired == true) {
          if (_self.selectedImage1 === '') {
            _self.handleError('Please Upload an Image');
            return
          }
        }
        _self.previousStep = 4
        _self.initStep5()
      })
      $prev.on('click', function (e) {
        _self.previousStep = 4
        _self.initStep3()
      })
    }
    if (_self.currentStep == 5) {
      $prev.attr('disabled', false).removeClass('is-hidden')
      $next.attr('disabled', false).removeClass('is-hidden')
      $next.on('click', function (e) {
        //               if(_self.selectedImage2 === ''){
        //               	_self.handleError('Please Upload an Image')
        //                 return
        //               }
        _self.previousStep = 5
        _self.initStep6()
      })
      $prev.on('click', function (e) {
        _self.previousStep = 5
        _self.initStep4()
      })
    }
    if (_self.currentStep == 6) {
      $prev.attr('disabled', false).removeClass('is-hidden')
      $next.attr('disabled', false).removeClass('is-hidden')
      $next.on('click', function (e) {
        //               if(_self.selectedImage3 === ''){
        //               	_self.handleError('Please Upload an Image')
        //                 return
        //               }
        _self.previousStep = 6
        _self.initStep7()
      })
      $prev.on('click', function (e) {
        _self.previousStep = 6
        _self.initStep5()
      })
    }

    if (_self.currentStep == 7) {
      $prev.attr('disabled', false).removeClass('is-hidden')
      $next.attr('disabled', false).removeClass('is-hidden')
      $next.on('click', function (e) {
        _self.previousStep = 7
        _self.initStep8()
      })
      $prev.on('click', function (e) {
        _self.previousStep = 7
        _self.initStep6()
      })
    }
    if (_self.currentStep == 8) {
      $prev.attr('disabled', false).removeClass('is-hidden')
      $next.attr('disabled', false).removeClass('is-hidden')
      $next.on('click', function (e) {
        _self.previousStep = 8
        _self.initStep9()
      })
      $prev.on('click', function (e) {
        _self.previousStep = 8
        _self.initStep7()
      })
    }




  },
  handleError: function handleError(error) {
    this.$section.find('[data-error]').removeClass('is-hidden').text(error)
  },
  unload: function unload($section) { }
};
